/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef, Suspense, lazy } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  transactionAction,
  getSendAndRecieveAction,
  getTradesAction,
} from "../../../../../store/Actions/TransactionActions";
import { TableTab, TableTabStyle } from "../../../../Units/TabsAndLinkStyled";
import DashboardHeader from "../../DashboardHeader";
import { withTheme } from "styled-components";
import { ActivitiesTable } from "../ActivitiesTable";
import {
  groupActivitiesByDaysOrMonth,
  filterPendingOrMatchedTransactions,
} from "../../../../../utils/specialFunctions";
import { Badge, DefaultButton } from "../../../../../UI toolkit/Button/Button";
import ActivitiesTableTab from "../ActivitiesTableTab";
// const SendAndRecieve = lazy(() => import('./SendAndRecieve'));
// import TradeActivities from './TradeActivities';
const TradeActivities = lazy(() => import("./TradeActivities"));

const Activities = ({
  transactionsList,
  trades,
  transfers,
  loading,
  theme,
  currencies,
  transfer_filters,
  prices,
  activeTab,
  getTradesAction,
  overviewAction,
  page,
  activeCurrency,
}) => {
  const location = useLocation();
  const [activeLink1, handleActiveLink1] = useState(0);

  const links = [
    { text: "Trades", link: "trades" },
    {
      text: "Send/Receive",
      link: "transfers",
      type: "all",
      status: "not_pending",
    },
    { text: "Incoming", link: "receive", type: "receive", status: "pending" },
    {
      text: "Pending Transfers",
      link: "send",
      type: "send",
      status: "pending",
    },
  ];
  const firstRun = useRef(false);

  const [transferType, setTransferType] = useState("all");
  const [transferStatus, setTransferStatus] = useState("all");
  let history = useHistory();
  useEffect(() => {
    getTradesAction();
  }, [activeTab, getTradesAction, page, activeCurrency]);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Activities</title>
        <link rel="canonical" href={location.pathname} />
      </Helmet>
      <Suspense
        fallback={
          <div
            className="flex items-center justify-center"
            style={{ height: "100vh" }}
          >
            <h1>Loading...</h1>
          </div>
        }
      >
        <div>
          <DashboardHeader>Activities</DashboardHeader>

          {loading ? (
            <div
              className="flex items-center justify-center"
              style={{ height: "100vh" }}
            >
              <h1>Loading...</h1>
            </div>
          ) : (
            <div>
              <div className="pt-0">
                <div className="flex flex-wrap justify-between overflow-hidden w-full">
                  <div>
                    <ActivitiesTableTab
                      links={links}
                      activeLink1={activeLink1}
                    />
                  </div>

                  <div className="flex justify-end">
                    <DefaultButton
                      small
                      p={"8px 16px"}
                      color={theme.colors.color}
                      bg={theme.colors.bg}
                    >
                      <Link to={"/dashboard/download-activities"}>
                        Download Activities
                      </Link>
                    </DefaultButton>
                  </div>
                </div>

                <div className="">
                  <TradeActivities
                    theme={theme}
                    getTradesAction={getTradesAction}
                    activities={trades ? trades : null}
                    currencies={currencies ? currencies : null}
                    prices={prices ? prices : null}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </Suspense>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    trades: state.transactions.trades,
    activeTab: state.transactions.tradesActiveTab,
    loading: state.transactions.loading,
    error: state.overview.error,
    currencies: state.overview.currencies,
    prices: state.overview.prices,
    page: state.transactions.tradesPage,
    activeCurrency: state.transactions.tradesActiveCurrency,
  };
};

// Link Actions to component
const mapDispatchToProps = (dispatch) => {
  return {
    getTradesAction: (query) => dispatch(getTradesAction(query)),
    // overviewAction: () => dispatch(overviewAction()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTheme(Activities)));

// eslint-disable-next-line no-lone-blocks
{
  /* <TableTab
mobileWidth={"25%"}
margin
tabs={links} 
activeTab={activeLink1} 
handleTab={handleActiveLink1}
p={"16px 0px"}
boxShadow={"0px"}
borderRadius={"0px"}
activeBg={"#FAFBFD"}
activeColor={"#005674"}
color={"#646A86"}
activeOutline={"none"}
activeOutlineBottom={"2px solid #005674"}
tailwindpad
callback={(active)=>{
    console.log(active)
}}
/> */
}
